import React, {Component} from 'react'
import CPageNew from '@/components/CPageNew'
import CBaseComponent from '@/components/CBaseComponent'
import { storeManageListNewData} from './data'
import {setPageNewItem} from "@/utils";
import './index.scss'
import { getStorage,gotonext} from "@/utils";import {
  refreshMenu,
} from "../../../../../../redux/common/action";
import {getInfo} from "../../../../../../servers/menuAPI";
import {savedata} from "../../../../../../servers/commonApi";
import {bindActionCreators, compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {message, Modal} from "antd";
import {dpeannexdefmap,dpeselectmap} from "../../../../../../utils/dpedatadef";

@CBaseComponent
class Output extends Component{

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChangeEdit = this.onChangeEdit.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onChange = this.onChange.bind(this)
  }


  state = {
    data: storeManageListNewData,
  }

  onChange(value){
    const data = this.state.data
    data[0].data.forEach((item,index)=>{
      if (item.id === value.data.id) {
        item.value = value.value
      }
    })
    this.setState({
      data:data
    })
  }

  onChangeEdit(data){
    const result = this.state.data
    const d = result[0].data
    d.forEach(item=>{
      if (item.id === data.id){
        item.ifEdit = !item.ifEdit
        if (data.hasupload!== '') {
          d.forEach(item1=>{
            if (item1.id === data.hasupload){
              item1.ifEdit = !item1.ifEdit
            }
          })
        }
      }
    })
    this.setState({
      data:result
    })
  }

  onSelect(){
    const params = {
      annual:localStorage.getItem('year'),
      indid:'2.1.1'
    }
    getInfo(params).then(res=>{
            if (res.pagetips) {
        const data = this.state.data
        data[0].pagetips = res.pagetips
        this.setState({
          data:data
        })
      } else {
        const data = this.state.data
        data[0].pagetips = ''
        this.setState({
          data:data
        })
      }
      const data = []
      res.records.forEach((item,index)=>{
        const obj = {}
        obj.id = item.code
        obj.name = item.name
        obj.placeholder=''
        obj.type= item.type === '1G10' ? 'input':'textarea'
        obj.zhengshu1= index === 0 || index === 1 || index === 2 || index === 3 || index === 4 || index === 5?true:false
        obj.checkType= item.minlimit > 0 ? 'required' : ''
        obj.newDisabled=false
        obj.editDisabled=false
        obj.newShow=true
        obj.editShow=true
        obj.ifEdit=item.type === '1G10' && item.annuname !=='' ? true : false
        obj.value= item.fillin ? decodeURIComponent(item.fillin): ''
        obj.options=[]
        obj.expand = {
          autosize: {minRows: 4, maxRows: 10}
        }
        obj.hasupload = ''
        obj.jpath = item.code
        obj.tips = item.formtips
        obj.showeditbtn = item.type === '1G10' && item.annuname!=='' ? true : false
        data.push(obj)
        if (item.annexdefids !== '' && item.annexdefids!==undefined) {
          const arr = item.annexdefids.split(',')
          arr.forEach(item1=>{
            const info = JSON.parse(JSON.stringify(dpeannexdefmap[item1]))
            const d = {
              id: info.id,
              name: '附件'+info.id+'.'+info.name,
              placeholder: '',
              type: 'img',
              checkType: '',
              newDisabled: false,
              editDisabled: false,
              newShow: true,
              editShow: true,
              value: item.annexlist,
              options: [],
              jpath:info.id,
              expand: {
                limit: 100
              },
              btnname: '附件',
            }
            data.push(d)
          })
        }
        if (index === 6) {
          for (let i= 0;i<13;i++){
            const specialobj = {}
            specialobj.id =  i===0?'dbxyjcgmc':i===1?'dbxyjcgdywcr':i===2?'dbxyjcghjxx':i===3?'dbxyjcgzyhzdw':i===4?'dbxyjcgsxmzz':i===5?'dbxyjcgxmjb':i===6?'dbxyjcgxmmc':i===7?'dbxyjcgxmbh':i===8?'dbxyjcgxmje':i===9?'dbxyjcgzscb':i===10?'dbxyjcgkwsylx':i===11?'dbxyjcgwzmc':'dbxyjcgkwmc'
            specialobj.name = i===0?'成果名称':i===1?'第一完成人':i===2?'获奖信息':i===3?'主要合作单位或合作者':i===4?'是否受项目资助':i===5?'项目级别':i===6?'项目名称':i===7?'项目编号':i===8?'项目金额（万元）':i===9?'是否正式出版或发表':i===10?'刊物索引类型':i===11?'文章或著作名称':'刊物名称及年卷期号'
            specialobj.placeholder= i ===2?'请选择获奖信息':i ===4?'请选择是否受项目资助':i ===5?'请选择项目级别':i ===9?'请选择是否正式出版或发表':i ===10?'请选择刊物索引类型':''
            specialobj.type = i===2 || i === 5 || i ===4 || i=== 10 ||i=== 9?'select':i=== 8?'number':'input'
            specialobj.checkType= item.minlimit > 0 ? 'required' : ''
            specialobj.newDisabled=false
            specialobj.editDisabled=false
            specialobj.newShow=true
            specialobj.editShow=true
            specialobj.ifEdit=false
            specialobj.value= i===0?res.extra.dbxyjcgmc.toString():i===1?res.extra.dbxyjcgdywcr.toString():i===2?res.extra.dbxyjcghjxx.toString():i===3?res.extra.dbxyjcgzyhzdw.toString():i===4?res.extra.dbxyjcgsxmzz.toString():i===5?res.extra.dbxyjcgxmjb.toString():i===6?res.extra.dbxyjcgxmmc.toString():i===7?res.extra.dbxyjcgxmbh.toString():i===8?res.extra.dbxyjcgxmje.toString():i===9?res.extra.dbxyjcgzscb.toString():i===10?res.extra.dbxyjcgkwsylx.toString():i===11?res.extra.dbxyjcgwzmc.toString():res.extra.dbxyjcgkwmc.toString()
            specialobj.options= i===2?dpeselectmap['1J']:i===4?[{id:'y',name:'是'},{id:'n',name:'否'}]:i===5?dpeselectmap['1K']:i===10?dpeselectmap['1L']:i===9?[{id:'y',name:'是'},{id:'n',name:'否'}]:[]
            specialobj.expand = {}
            specialobj.hasupload = ''
            specialobj.jpath =  i===0?'dbxyjcgmc':i===1?'dbxyjcgdywcr':i===2?'dbxyjcghjxx':i===3?'dbxyjcgzyhzdw':i===4?'dbxyjcgsxmzz':i===5?'dbxyjcgxmjb':i===6?'dbxyjcgxmmc':i===7?'dbxyjcgxmbh':i===8?'dbxyjcgxmje':i===9?'dbxyjcgzscb':i===10?'dbxyjcgkwsylx':i===11?'dbxyjcgwzmc':'dbxyjcgkwmc'
            specialobj.tips = ''
            obj.showeditbtn = false
            data.push(specialobj)
          }
        }
      })
 const obj = JSON.parse(JSON.stringify(this.state.data))
      obj[0].data = data
      this.setState({
        data:obj
      })
      const element = document.getElementById('top');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' }); // 平滑滚动到元素位置
      }
    })
  }

  onSubmit(data){
    Modal.confirm({
      content: '确认提交数据',
      okText: '确认',
      cancelText: '取消',
      onCancel:()=>{
      },
      onOk:()=>{
        this.onSubmitHandler(data)
      }
    })
  }

  //下一步
  onCancel(data){
    Modal.confirm({
      content: '确认提交数据到下一个填报页面?',
      okText: '确认',
      cancelText: '取消',
      onOk:()=>{
        this.onSubmitHandler(data,'tz')
      }
    })
  }

  onSubmitHandler(data, type=''){
    if (data.status){
      for (let key in data.data) {
        if (typeof data.data[key] !== 'string' && typeof data.data[key] !== 'number'){
          delete data.data[key]
        }
      }
      const params = JSON.parse(JSON.stringify(data.data))
      params.annual = localStorage.getItem('year')
      savedata(params).then(res=>{
        if(res.statecode === 0) {
          this.props.refreshMenu(true)
          message.success('保存成功');
           if (type === 'tz'){
            gotonext()
            this.props.history.push({
              pathname: '/informationDeclaration/service/science/service',
            });
          }
        } else {
          message.error(res.statemessage);
        }
      })
    }
  }

  componentDidMount(){
    this.onSelect()
  }

  render(){
    return (
      <div className='store-manage-list-new' id='top'>
        <CPageNew
            data={this.state.data}
            onChange={this.onChange}
            onSubmit={this.onSubmit}
            onCancel={this.onCancel}
            onChangeEdit={this.onChangeEdit}
        />
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    year: state.year,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
  };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Output);

